import { render, staticRenderFns } from "./PlatformBlockingArtikelsComponent.vue?vue&type=template&id=aebbe9d6&"
import script from "./PlatformBlockingArtikelsComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformBlockingArtikelsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports